import {
  ApiOutlined,
  AppstoreOutlined,
  BarChartOutlined,
  FileTextOutlined,
  HomeOutlined,
  ProfileOutlined,
  QuestionCircleOutlined,
  TagsOutlined,
  TeamOutlined,
} from '@ant-design/icons';

import { Path } from '@/enums';
import { AdminSidebarLink } from '@/types/components';

export const adminLinks: AdminSidebarLink[] = [
  {
    label: '總覽',
    to: Path.AdminDashboard,
    icon: <HomeOutlined />,
    group: '首頁',
    description: '查看系統概況，快速前往各管理功能。',
  },
  {
    label: '問卷管理',
    to: Path.AdminQuestionnaires,
    icon: <FileTextOutlined />,
    group: '問卷與成果',
    description: '查看、建立與管理所有問卷。',
  },
  {
    label: '結果統計',
    to: Path.AdminResults,
    icon: <BarChartOutlined />,
    group: '問卷與成果',
    description: '查看問卷結果與 SDGs 分數統計。',
  },
  {
    label: '題目庫',
    to: Path.AdminQuestions,
    icon: <QuestionCircleOutlined />,
    group: '題庫設定',
    description: '管理所有問卷題目與題目內容。',
  },
  {
    label: '問題模組',
    to: Path.AdminQuestionModules,
    icon: <TagsOutlined />,
    group: '題庫設定',
    description: '管理問題模組與題目分類。',
  },
  {
    label: '答案選項集',
    to: Path.AdminAnswerOptionSets,
    icon: <AppstoreOutlined />,
    group: '題庫設定',
    description: '管理答案選項集與選項內容。',
  },
  {
    label: '用戶管理',
    to: Path.AdminUsers,
    icon: <TeamOutlined />,
    group: '系統管理',
    description: '管理用戶帳號、驗證狀態與權限。',
  },
  {
    label: 'API 日誌',
    to: Path.AdminApiLogs,
    icon: <ApiOutlined />,
    group: '系統管理',
    description: '查看系統 API 請求紀錄與錯誤。',
  },
];

export const defaultAdminIcon = <ProfileOutlined />;

/** 依目前網址找出對應的導覽項目（以最長相符路徑為準）。 */
export const findAdminLink = (pathname: string) => {
  const normalized =
    pathname.length > 1 ? pathname.replace(/\/$/, '') : pathname;
  return adminLinks
    .filter(
      (link) =>
        normalized === link.to ||
        (link.to !== Path.AdminDashboard &&
          normalized.startsWith(`${link.to}/`)),
    )
    .sort((a, b) => b.to.length - a.to.length)[0];
};
